import { render, staticRenderFns } from "./UserRequisites.vue?vue&type=template&id=cbbc955e&scoped=true&"
import script from "./UserRequisites.vue?vue&type=script&lang=js&"
export * from "./UserRequisites.vue?vue&type=script&lang=js&"
import style0 from "./UserRequisites.vue?vue&type=style&index=0&id=cbbc955e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc955e",
  null
  
)

export default component.exports